import { IVendorQuote, IVendorQuoteMainInfoForm, IVendorQuoteMainInfoPayload } from 'quotes/types';

export const getDefaultValues = (quote?: IVendorQuote): IVendorQuoteMainInfoForm => ({
  externalNumber: quote?.externalNumber || quote?.vendorQuoteNumber || '',
  revisionNumber: quote?.revisionNumber || '',
  vendorLocation:
    quote?.vendorApNumber || quote?.vendorLocationName || quote?.vendorName
      ? {
          accountsPayableId: quote.vendorApNumber,
          name: quote.vendorLocationName || quote.vendorName || quote.vendorApNumber,
        }
      : null,
});

// An absent key leaves the column untouched server-side, so only what the user changed is sent.
export const mapVendorQuoteMainInfoForm = (
  quoteId: number,
  initial: IVendorQuoteMainInfoForm,
  values: IVendorQuoteMainInfoForm
): IVendorQuoteMainInfoPayload => {
  const externalNumber = values?.externalNumber?.trim() ?? '';
  const revisionNumber = values?.revisionNumber?.trim() ?? '';

  return {
    quote: {
      id: quoteId,
      ...(externalNumber !== (initial?.externalNumber?.trim() ?? '') && { externalNumber }),
      ...(revisionNumber !== (initial?.revisionNumber?.trim() ?? '') && { revisionNumber }),
      ...(values?.vendorLocation?.id && { vendorLocationId: values.vendorLocation.id }),
    },
  };
};
